import {
  Component,
  computed,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { HugeiconsIconComponent } from './hugeicons-icon.component';
import { resolveIcon, type IconName, type IconVariant } from './icon-registry';

@Component({
  selector: 'ui-icon',
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HugeiconsIconComponent],
})
export class IconComponent {
  public readonly name = input.required<IconName>();
  public readonly variant = input<IconVariant | null>('auto');
  public readonly stroke = input<number | undefined>(undefined);

  public readonly icon = computed(() =>
    resolveIcon(this.name(), this.variant() || 'auto'),
  );
}
